import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from "@reduxjs/toolkit";
import {RootState} from "@/store/Store";
import {OrderAction} from "@/features/DNAOrderContent/Config/orderStatusConfig";


export interface SelectedOrder {
    id: number;
    number: string;
    statusAlias: string;
    contactDateAgreeming: string | null;
    trackNumber?: string | null;
    isMainDealWithNoOtherTransferred?: boolean;
}

export interface SelectionErrorReport {
    type: 'ERROR' | 'WARNING' | null;
    message: string;
    invalidOrders: { id: number; number: string }[];
    actionType: OrderAction | null;
}

interface DNAOrdersState {
    unreadMessagesFilter: string;
    page: number;
    selectedOrders: SelectedOrder[];
    selectionError: SelectionErrorReport | null;
}

function getInitialState(): DNAOrdersState {
    return {
        // rowsInTable: 25,
        // dateSorting: "notChosen",
        //
        // orderedTestTypes: [] as TestTypeRowInterface[],
        // testTypeAlphabetSorting: "notChosen",
        //
        // selectedStatuses: [] as StatusUnitInterface[],

        unreadMessagesFilter: "notChosen",
        page: 1,
        selectedOrders: [],
        selectionError: null,
    };
}

export const DNAOrdersFiltersAndSortersSlice = createSlice({
    name: "DNAOrdersFiltersAndSortersSlice",
    initialState: getInitialState(),
    reducers: {
        // setRowsInTable: (state, action: PayloadAction<rowsInTableVariantsValues>) => {
        //     state.rowsInTable = action.payload;
        // },
        //
        // addOrderedTestType: (state, action: PayloadAction<TestTypeRowInterface>) => {
        //     state.orderedTestTypes.push(action.payload);
        // },
        // removeOrderedTestType: (state, action: PayloadAction<TestTypeRowInterface>) => {
        //     state.orderedTestTypes = state.orderedTestTypes.filter(type => type.alias !== action.payload.alias);
        // },
        // clearOrderedTestTypes: (state, action) => {
        //     state.orderedTestTypes = [];
        // },
        // setOrderedTestTypes: (state, action: PayloadAction<TestTypeRowInterface[]>) => {
        //     state.orderedTestTypes = action.payload;
        // },
        //
        // setDateSorting: (state, action: PayloadAction<string>) => {
        //     state.dateSorting = action.payload;
        // },
        //
        // setTestTypeAlphabetSorting: (state, action: PayloadAction<string>) => {
        //     state.testTypeAlphabetSorting = action.payload;
        // },
        //
        // addStatus: (state, action: PayloadAction<StatusUnitInterface>) => {
        //     state.selectedStatuses.push(action.payload);
        // },
        // removeStatus: (state, action: PayloadAction<StatusUnitInterface>) => {
        //     state.selectedStatuses = state.selectedStatuses.filter(status => status.alias !== action.payload.alias);
        // },
        // clearStatuses: (state, action) => {
        //     state.selectedStatuses = [];
        // },
        // setStatuses: (state, action: PayloadAction<StatusUnitInterface[]>) => {
        //     state.selectedStatuses = action.payload;
        // },

        setUnreadMessagesFilter: (state, action: PayloadAction<string>) => {
            state.unreadMessagesFilter = action.payload;
        },
        setPage: (state, action: PayloadAction<number>) => {
            state.page = action.payload;
        },

        clearSelection: (state) => {
            state.selectedOrders = [];
        },
        toggleSelectAll: (state, action: PayloadAction<SelectedOrder[]>) => {
            const incomingItems = action.payload;
            const allSelected = incomingItems.every(item =>
              state.selectedOrders.some(s => s.id === item.id)
            );

            if (allSelected) {
                const idsToRemove = incomingItems.map(i => i.id);
                state.selectedOrders = state.selectedOrders.filter(s => !idsToRemove.includes(s.id));
            } else {
                incomingItems.forEach(item => {
                    if (!state.selectedOrders.some(s => s.id === item.id)) {
                        state.selectedOrders.push(item);
                    }
                });
            }
        },
        toggleSelectRow: (state, action: PayloadAction<SelectedOrder>) => {
            const index = state.selectedOrders.findIndex(s => s.id === action.payload.id);
            if (index !== -1) {
                state.selectedOrders.splice(index, 1);
            } else {
                state.selectedOrders.push(action.payload);
            }
        },
        setSelectionError: (state, action: PayloadAction<SelectionErrorReport | null>) => {
            state.selectionError = action.payload;
        },
        clearSelectionError: (state) => {
            state.selectionError = null;
        },
    }
});

export const {
    // setRowsInTable,
    // addOrderedTestType,
    // removeOrderedTestType,
    // clearOrderedTestTypes,
    // setOrderedTestTypes,
    // setDateSorting,
    // setTestTypeAlphabetSorting,
    // addStatus,
    // removeStatus,
    // clearStatuses,
    // setStatuses,
    setUnreadMessagesFilter,
    setPage,
    clearSelection,
    toggleSelectAll,
    toggleSelectRow,
    setSelectionError,
    clearSelectionError,
} = DNAOrdersFiltersAndSortersSlice.actions;

// export const orderedTestTypesSelector = (state: RootState) => state.dnaOrdersFiltersAndSorters.orderedTestTypes;
// export const rowsInTableSelector = (state: RootState) => state.dnaOrdersFiltersAndSorters.rowsInTable;
// export const dateSortingSelector = (state: RootState) => state.dnaOrdersFiltersAndSorters.dateSorting;
// export const testTypeAlphabetSortingSelector = (state: RootState) => state.dnaOrdersFiltersAndSorters.testTypeAlphabetSorting;
// export const selectedStatusesSelector = (state: RootState) => state.dnaOrdersFiltersAndSorters.selectedStatuses;
export const unreadMessagesSelector = (state: RootState) => state.dnaOrdersFiltersAndSorters.unreadMessagesFilter;
// export const pageSelector = (state: RootState) => state.dnaOrdersFiltersAndSorters.page;

export const selectedOrdersSelector = (state: RootState) => state.dnaOrdersFiltersAndSorters.selectedOrders

export const selectionErrorSelector = (state: RootState) => state.dnaOrdersFiltersAndSorters.selectionError;

export const DNAOrdersFiltersAndSortersReducer = DNAOrdersFiltersAndSortersSlice.reducer;

export const rowsInTableVariants = {
    "25": 25,
    "50": 50,
    "100": 100,
} as const;
type rowsInTableVariantsKeys = keyof typeof rowsInTableVariants;
export type rowsInTableVariantsValues = (typeof rowsInTableVariants)[rowsInTableVariantsKeys];
